export const debounce = (fn, timeoutMs, obj) => {
    const state = obj?.current ?? { lastCall: 0, lastCallTimer: null };

    return function perform(...args) {
        const now = Date.now();
        const previousCall = state.lastCall;
        state.lastCall = now;

        if (previousCall && now - previousCall <= timeoutMs) {
            clearTimeout(state.lastCallTimer);
        }

        state.lastCallTimer = setTimeout(() => fn(...args), timeoutMs);
    };
};
